import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDrag } from 'react-dnd';
import {
  IconButton, ListItemButton, ListItemIcon, ListItemText,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen } from '@fortawesome/free-regular-svg-icons';
import { faFolderClosed, faMinus } from '@fortawesome/free-solid-svg-icons';
import ItemTypes from '../itemTypes';

function Field({
  name, label, onClick, active, onDblClick, level, onToggleOpen, opened, hasChild,
}) {
  const [{ isDragging }, ref] = useDrag({
    item: { name, type: ItemTypes.availableField },
    type: ItemTypes.availableField,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const dragProps = useMemo(() => ({
    opacity: isDragging ? 0.4 : 1,
  }), [isDragging]);

  const icon = useMemo(
    () => {
      if (!hasChild) return faMinus;
      if (opened) return faFolderOpen;
      return faFolderClosed;
    },
    [hasChild, opened],
  );

  return (
    <ListItemButton
      sx={{ pl: (level + 1) * 2, ...dragProps }}
      selected={active}
      onClick={() => onClick(name)}
      onDoubleClick={() => onDblClick(name)}
    >
      <ListItemIcon sx={{ width: 30, minWidth: 30 }}>
        <IconButton
          onClick={() => onToggleOpen(name)}
          size="small"
          disabled={!hasChild}
          color="success"
        >
          <FontAwesomeIcon
            icon={icon}
          />
        </IconButton>
      </ListItemIcon>
      <ListItemText ref={ref}>
        {label}
      </ListItemText>
    </ListItemButton>
  );
}

Field.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onDblClick: PropTypes.func.isRequired,
  active: PropTypes.bool,
  level: PropTypes.number,
  onToggleOpen: PropTypes.func.isRequired,
  opened: PropTypes.bool,
  hasChild: PropTypes.bool,
};

Field.defaultProps = {
  active: false,
  level: 0,
  opened: false,
  hasChild: false,
};

export default memo(Field);
